import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { ServiceCard } from "../components/services/ServiceCard";
import { Seo } from "../components/Seo";
import { useT } from "../i18n/I18nProvider";

const IMAGES = [
  "https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHwzZCUyMGFic3RyYWN0JTIwbWluaW1hbGlzdCUyMHdoaXRlfGVufDB8fHx8MTc4NzMwMzkxNnww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/17509939/pexels-photo-17509939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/29652319/pexels-photo-29652319.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7675029/pexels-photo-7675029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function Services() {
  const t = useT();
  const items = t("services.items");

  return (
    <>
      <Seo page="servizi" />
      {/* HEADER */}
      <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pt-16 md:pt-24 pb-14 md:pb-20">
        <Reveal>
          <div className="overline mb-4 md:mb-6">{t("services.header.overline")}</div>
        </Reveal>
        <Reveal delay={80}>
          <h1 className="font-display text-5xl sm:text-7xl md:text-8xl lg:text-[9vw] leading-[0.92] tracking-tightest max-w-[13ch]">
            {t("services.header.title1")}
            <br />
            <span className="font-editorial text-ink-700">
              {t("services.header.titleEditorial")}
            </span>
            {t("services.header.titleEnd")}
          </h1>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-6 md:mt-10 text-[15px] md:text-[17px] text-ink-500 max-w-2xl leading-relaxed">
            {t("services.header.paragraph")}
          </p>
        </Reveal>
      </section>

      {/* SERVICES STACK */}
      <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pb-16 md:pb-24 space-y-5 md:space-y-6">
        {items.map((s, i) => (
          <ServiceCard key={s.tag} item={s} index={i} total={items.length} image={IMAGES[i]} />
        ))}
      </section>

      {/* CTA */}
      <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pb-16">
        <Reveal className="card-flat p-8 md:p-16 grid lg:grid-cols-12 gap-6 md:gap-8 items-center">
          <div className="lg:col-span-8">
            <div className="overline mb-3 md:mb-4">
              {t("services.cta.overline")}
            </div>
            <h3 className="font-display text-3xl sm:text-4xl md:text-5xl tracking-tightest">
              {t("services.cta.title1")}
              <br /> {t("services.cta.title2")}{" "}
              <span className="font-editorial text-ink-700">
                {t("services.cta.titleEditorial")}
              </span>
              {t("services.cta.titleEnd")}
            </h3>
          </div>
          <div className="lg:col-span-4 lg:justify-self-end">
            <Link to="/contatti" className="btn-pill" data-testid="services-cta">
              {t("services.cta.button")}
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.6} />
            </Link>
          </div>
        </Reveal>
      </section>
    </>
  );
}
